import {
  Directive,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Renderer2,
  ElementRef
} from '@angular/core';

import { Subscription, Observable } from 'rxjs';

@Directive({
  selector: '[asyncClick]'
})
export class AsyncClickDirective implements OnDestroy {
  private _subscription: Subscription;

  @Input('asyncClick') clickObservable;

  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef
  ) { }

  @HostListener('click')
  private onClick() {
    if (this.clickObservable instanceof Observable) {
      this.disable();
      let observable = this.clickObservable
        .finally(() => {
          this.enable();
        });
      this.unSubscribe();
      this._subscription = observable.subscribe();
    } else {
      console.error("asyncClick directive requires 'Observable' type")
    }
  }

  private disable() {
    this._renderer.setAttribute(
      this._elementRef.nativeElement,
      'disabled',
      'true'
    );
  }

  private enable() {
    this._renderer.removeAttribute(
      this._elementRef.nativeElement,
      'disabled'
    );
  }

  ngOnDestroy() {
    this.unSubscribe();
  }

  private unSubscribe() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/directives/async-click/async-click.directive.ts